export default __webpack_public_path__ + "img/square_2.5571e50e4745264402534e2a395a407f.jpg";